import { render, staticRenderFns } from "./MentionSuggestDropdown.vue?vue&type=template&id=412d2765&scoped=true&"
import script from "./MentionSuggestDropdown.vue?vue&type=script&lang=ts&"
export * from "./MentionSuggestDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412d2765",
  null
  
)

export default component.exports